<template>
  <div class="clients-manage" id="clientsManage">
    <second-menu-link-content>
      <template v-slot:header>
        <span>客户管理</span>
      </template>
      <template v-slot:content>
        <div
          v-show="
            operationList.findIndex(
              item => item === operationBtns.addCustomerBtn
            ) !== -1
          "
          class="btn-container"
        >
          <el-button class="btn-blue" @click="toAddClient">新增客户</el-button>
        </div>
        <div class="filter-custom-form-container" ref="formContainer">
          <el-form ref="filterClient" :model="filterClient" class="filter-customer-form">
            <div class="container">
              <el-form-item class="item" label="客户名称：" prop="name">
                <el-input
                  class="white"
                  clearable
                  v-model="filterClient.name"
                  placeholder="请输入客户名称"
                  @keyup.enter.native="toFilterClient"
                ></el-input>
              </el-form-item>
              <el-form-item class="item" label="客户标签：" prop="tagId">
                <el-select
                  class="white"
                  clearable
                  v-model="filterClient.tagId"
                  placeholder="请选择客户标签"
                >
                  <el-option
                    v-for="(tag, index) in tagList"
                    :key="index"
                    :value="tag.id"
                    :label="tag.name"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item" label="账号状态：" prop="status">
                <el-select
                  class="white"
                  clearable
                  v-model="filterClient.status"
                  placeholder="请选择账号状态"
                >
                  <el-option label="待审核" :value="0"></el-option>
                  <el-option label="已启用" :value="1"></el-option>
                  <el-option label="已禁用" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="item"
                label="客户等级："
                prop="grade"
                v-show="
                  operationList.findIndex(
                    item => item === operationBtns.manageCustomerGrade
                  ) !== -1
                "
              >
                <el-select
                  class="white"
                  clearable
                  v-model="filterClient.clientGrade"
                  placeholder="请选择客户等级"
                >
                  <el-option
                    v-for="item in clientGradeList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="container">
              <el-form-item class="item date-item" label="注册时间：" prop="createTime" style="width: 355px">
                <el-date-picker
                  v-model="filterClient.createTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="check-item" prop="hideDisabledFlag">
                <el-checkbox class="check" v-model="filterClient.hideDisabledFlag" @change="changeIsAccount"
                  >隐藏禁用账号</el-checkbox
                >
              </el-form-item>
              <el-form-item class="check-item" prop="bindEmployee">
                <el-checkbox class="check" v-model="filterClient.bindEmployee" @change="changeBindSalespersonFlag"
                  >未绑定业务员</el-checkbox
                >
              </el-form-item>
            </div>
            <div class="operations">
              <el-button class="btn-blue" @click="toFilterClient">筛选</el-button>
              <el-button
                @click="exportExcel"
                v-show="
                  operationList.findIndex(
                    item => item === operationBtns.exportCustomerBtn
                  ) !== -1
                "
                class="btn-white"
              >导出报表</el-button>
              <span class="reset-btn" @click="resetClientForm">清空筛选条件</span>
            </div>
          </el-form>
        </div>
        <div class="table" ref="clientList">
          <el-table class="table-container" :data="customerList">
            <el-table-column label="客户名称" prop="name" min-width="140">
              <template slot-scope="props">
                <p class="name" :title="props.row.name">{{props.row.name}}</p>
              </template>
            </el-table-column>
            <el-table-column label="登录账号" prop="userName" min-width="100"></el-table-column>
            <el-table-column label="联系人" prop="contact" min-width="80"></el-table-column>
            <el-table-column label="手机号" prop="telephone" min-width="120"></el-table-column>
            <el-table-column label="账号状态" prop="statusDesc" min-width="100">
              <template slot-scope="props">
                <span class="green" v-if="props.row.statusDesc==='已启用'"></span>
                <span class="orange" v-else-if="props.row.statusDesc==='已禁用'"></span>
                <span v-else class="white"></span>
                <span>{{props.row.statusDesc}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="客户等级"
              prop="levelName"
              min-width="100"
              v-if="
                operationList.findIndex(
                  item => item === operationBtns.manageCustomerGrade
                ) !== -1
              "
            ></el-table-column>
            <el-table-column label="客户标签" prop="tags" width="290">
              <template slot-scope="props">
                <ul class="tags" v-show="props.row.tags.length">
                  <li class="tag" v-for="tag in props.row.tags" :key="tag.id">{{ tag.name }}</li>
                </ul>
                <p class="tip" v-show="!props.row.tags.length">暂无标签</p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="最后登陆" prop="lastLoginTime" width="180"></el-table-column> -->
            <el-table-column label="操作" min-width="180">
              <template slot-scope="props">
                <div class="operation">
                  <div class="btn-container" v-show="props.row.status === xbUserStatusEnum.initial">
                    <span class="column-btn" @click="toDetail(props.row)">详情</span>
                    <span
                      v-show="
                        operationList.findIndex(
                          item => item === operationBtns.manageCustomerStatusBtn
                        ) !== -1
                      "
                      class="column-btn"
                      @click="toCheckClient(props.row)"
                    >审核</span>
                  </div>
                  <div class="btn-container" v-show="props.row.status === xbUserStatusEnum.effective">
                    <span class="column-btn" @click="toAddTag(props.row)">修改标签</span>
                    <span class="column-btn" @click="toDetail(props.row)">详情</span>
                    <!-- <span
                      v-show="
                        operationList.findIndex(
                          item => item === operationBtns.manageCustomerStatusBtn
                        ) !== -1
                      "
                      class="column-btn"
                      @click="updateClientStatus(props.row)"
                    >禁用</span> -->
                  </div>
                  <div
                    class="btn-container"
                    v-show="
                      props.row.status === xbUserStatusEnum.unEffective ||
                        props.row.status === xbUserStatusEnum.notPass
                    "
                  >
                    <span class="column-btn" @click="toDetail(props.row)">详情</span>
                    <!-- <span
                      v-show="
                        operationList.findIndex(
                          item => item === operationBtns.manageCustomerStatusBtn
                        ) !== -1
                      "
                      class="column-btn"
                      @click="updateClientStatus(props.row)"
                    >启用</span> -->
                  </div>
                  <!-- <span class="column-btn" @click="toCoupon(props.row)">优惠券</span> -->
                  <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="client-dropdown">
                      <el-dropdown-item :command="beforeHandleCommand(6, props.row)">购买记录</el-dropdown-item>
                      <el-dropdown-item :command="beforeHandleCommand(1, props.row)">优惠券</el-dropdown-item>
                      <!-- <el-dropdown-item :command="beforeHandleCommand(2, props.row)">详情</el-dropdown-item> -->
                      
                      <!-- <el-dropdown-item :command="beforeHandleCommand(5, props.row)">登录详情</el-dropdown-item> -->
                      <el-dropdown-item 
                        v-show="
                          (operationList.findIndex(
                            item => item === operationBtns.manageCustomerStatusBtn
                          ) !== -1)&&(props.row.status === xbUserStatusEnum.effective)
                        " 
                        :command="beforeHandleCommand(2, props.row)"
                      >禁用</el-dropdown-item>
                      <el-dropdown-item :command="beforeHandleCommand(3, props.row)">积分</el-dropdown-item>
                      <el-dropdown-item
                        v-show="
                          (operationList.findIndex(
                            item => item === operationBtns.manageCustomerStatusBtn
                          ) !== -1)&&(props.row.status === xbUserStatusEnum.unEffective ||
                        props.row.status === xbUserStatusEnum.notPass)
                        "
                       :command="beforeHandleCommand(4, props.row)"
                      >启用</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-tpl-container">
          <pagination-tpl
            class="pagination-tpl"
            :total="customerListTotal"
            :currentPage="currentPage"
            @queryChange="handleQueryChange"
          ></pagination-tpl>
        </div>
        <!-- 客户修改标签--弹框 -->
        <el-dialog class="add-tag-container" :visible.sync="showTagDialog">
          <template slot="title">
            <span class="title">修改标签</span>
          </template>
          <template>
            <div class="content">
              <div class="add-tag-value">
                <span class="desc">客户标签：</span>
                <el-select
                  class="gray"
                  v-model="selectedTags"
                  multiple
                  filterable
                  default-first-option
                  placeholder="请选择客户标签"
                >
                  <el-option
                    v-for="(item, index) in tagList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="operation">
                <el-button class="btn-white cancel-btn btn" @click="cancelAddTag">取消</el-button>
                <el-button class="btn-blue save-btn btn" @click="saveAddTag">保存</el-button>
              </div>
            </div>
          </template>
        </el-dialog>
        <!-- 新增客户--弹框 -->
        <el-dialog class="add-customer-container" :visible.sync="showCustomerDialog">
          <template slot="title">
            <span class="title">添加客户</span>
          </template>
          <template>
            <div class="content">
              <el-form
                :model="customerForm"
                :rules="customerRules"
                ref="customerForm"
                label-width="100px"
                class="address-form"
              >
                <el-form-item label="登录账号：" prop="name">
                  <el-input v-model="customerForm.name" class="gray" placeholder="请输入登录账号"></el-input>
                </el-form-item>
                <el-form-item label="客户名称：" prop="company">
                  <el-input v-model="customerForm.company" class="gray" placeholder="请输入客户名称"></el-input>
                </el-form-item>
                <el-form-item label="联系人：" prop="contact">
                  <el-input v-model="customerForm.contact" class="gray" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="telephone">
                  <el-input v-model="customerForm.telephone" class="gray" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="所在区域：" prop="area">
                  <el-cascader
                    v-model="customerForm.area"
                    :options="addressList"
                    :props="cascaderProps"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" prop="address">
                  <el-input v-model="customerForm.address" class="gray" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="客户标签：" prop="tag">
                  <el-select
                    class="gray"
                    v-model="customerForm.selectedTags"
                    multiple
                    filterable
                    default-first-option
                    placeholder="请选择客户标签"
                  >
                    <el-option
                      v-for="item in tagList"
                      :key="item.value"
                      :value="item.id"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="客户等级："
                  v-show="
                    operationList.findIndex(
                      item => item === operationBtns.manageCustomerGrade
                    ) !== -1
                  "
                >
                  <el-select
                    class="gray"
                    v-model="customerForm.clientGrade"
                    clearable
                    placeholder="请选择客户等级"
                  >
                    <el-option
                      v-for="item in clientGradeList"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Email：" prop="email">
                  <el-input v-model="customerForm.email" class="gray" placeholder="请输入Email"></el-input>
                </el-form-item>
                <el-form-item label="QQ：" prop="qq">
                  <el-input v-model="customerForm.qq" class="gray" placeholder="请输入QQ"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="btn-white" type="primary" @click="resetCustomerForm">取消</el-button>
                  <el-button class="btn-blue" @click="addNewCustomer">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
          </template>
        </el-dialog>
        <!-- 积分 -->
        <el-dialog class="dialogIntegral" title="积分" :visible.sync="dialogIntegralVisible" width="320px" top="20vh">
          <el-form ref="integralForm" class="integralForm" :model="integralForm" label-width="100px">
            <el-form-item label="积分总额：" prop="integralAmount">
              <el-input
                class="white"
                v-model="integralForm.integralAmount"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="已用积分：" prop="usedPoint">
              <el-input
                class="white"
                v-model="integralForm.usedPoint"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="可用积分：" prop="availablePoints">
              <el-input
                class="white"
                v-model="integralForm.availablePoints"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="过期积分：" prop="overduePoints">
              <el-input
                class="white"
                v-model="integralForm.overduePoints"
                disabled
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialogIntegral-footer">
            <el-button class="btn-blue" type="primary" @click="saveIntegral('integralForm')">确认</el-button>
          </div>
        </el-dialog>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import { formaTimeToSecond } from "common/js/util";
import { getDBOperationPermission } from "common/js/storage";
import DBClient from "models/db/client.js";
import DBAddress from "models/db/address.js";
import DBExcel from "models/db/excel.js";
const dbClient = new DBClient();
const dbAddress = new DBAddress();
const dbExcel = new DBExcel();
const MAX_TAG_NUM = 5;
// 页面按钮--客户导出 新增客户 客户状态编辑 客户等级
const EXPORT_CUSTOMER = "ROLE_CUSTOMER_export";
const ADD_CUSTOMER = "ROLE_CUSTOMER_add";
const MANAGE_CUSTOMER_STATUS = "ROLE_CUSTOMER_manage";
const MANAGE_CUSTOMER_GRADE = "ROLE_CUSTOMER_level";
const xbUserStatusEnum = {
  // 前台注册的初始状态
  initial: 0,
  // 通过/启用
  effective: 1,
  // 禁用
  unEffective: 2,
  // 拒绝
  notPass: 3,
};
const statusDescEnum = {
  [xbUserStatusEnum.initial]: "待审核",
  [xbUserStatusEnum.effective]: "已启用",
  [xbUserStatusEnum.unEffective]: "已禁用",
  [xbUserStatusEnum.notPass]: "已拒绝",
};
export default {
  data() {
    const isTelephone = (mobileNumber) => {
      const reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
      return reg.test(mobileNumber);
    };
    const validateTelephone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        if (!isTelephone(value)) {
          callback(new Error("请输入有效手机号码"));
        }
        callback();
      }
    };
    return {
      xbUserStatusEnum: xbUserStatusEnum,
      // 当前列表页
      currentPage: 1,
      // 客户总数
      customerListTotal: 0,
      // 是否显示新增标签弹框
      showTagDialog: false,
      // 是否显示新增客户弹框
      showCustomerDialog: false,
      // 被点新增标签的客户
      willUpdateCustomer: {
        userId: 0,
        xbId: 0,
        name: "",
        contact: "",
        telephone: "",
        status: 0,
        statusDesc: "",
        createTime: "",
        tags: [],
      },
      // 选中的标签
      selectedTags: [],
      // 从服务器获取的客户标签列表
      tagList: [
        {
          // value存id值
          value: 0,
          // label 存name值
          label: "",
        },
      ],
      clientGradeList: [], // 等级列表
      // 筛选客户参数
      filterClient: {
        name: "",
        tagId: "",
        clientGrade: "",
        status: "",
        createTime: null,
        hideDisabledFlag: true,
        bindEmployee: false,
      },
      // 是否是无参数查询
      searchWithNoParam: true,
      // 上次的查询参数
      options: {
        name: "",
        tagId: "",
        clientGrade: "",
        status: "",
        createTime: null,
        currentPage: 1,
        hideDisabledFlag: 1,
        bindEmployee: false,
      },
      // 客户列表
      customerList: [],
      // 新增客户表单区域
      customerForm: {
        name: "",
        company: "",
        contact: "",
        telephone: "",
        area: "",
        address: "",
        selectedTags: [],
        clientGrade: "",
        email: "",
        qq: "",
      },
      // 新增客户表单区域校验规则
      customerRules: {
        name: {
          required: true,
          message: "请输入用户名称",
          trigger: "change",
        },
        company: {
          required: true,
          message: "请输入公司名称",
          trigger: "change",
        },
        contact: {
          required: true,
          message: "请输入联系人名称",
          trigger: "change",
        },
        telephone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "change",
          },
          {
            validator: validateTelephone,
            trigger: "blur",
          },
        ],
        area: {
          required: true,
          message: "请输入所在区域",
          trigger: "change",
        },
        address: {
          required: true,
          message: "请输入详细地址",
          trigger: "change",
        },
        selectedTags: {
          required: true,
          message: "请选择客户标签",
          trigger: "change",
        },
      },
      // 城市数据列表
      addressList: [],
      // Cascader 的 props 配置
      cascaderProps: {
        value: "id",
        label: "name",
      },
      // 页面操作按钮
      operationBtns: {
        exportCustomerBtn: EXPORT_CUSTOMER,
        addCustomerBtn: ADD_CUSTOMER,
        manageCustomerStatusBtn: MANAGE_CUSTOMER_STATUS,
        manageCustomerGrade: MANAGE_CUSTOMER_GRADE,
      },
      // 用户权限列表
      operationList: [],

      /* ------------------------ 以下为积分字段 ------------------------- */
      dialogIntegralVisible: false,
      integralForm: {
        integralAmount: '',
        usedPoint: '',
        availablePoints: '',
        overduePoints: ''
      }
    };
  },
  computed: {
    canSelectTagList() {
      let strArrOne = this.tagList
        .concat([])
        .map((item) => (item = JSON.stringify(item)));
      let strArrTwo = this.willUpdateCustomer.tags
        .concat([])
        .map((item) => (item = JSON.stringify(item)));
      let result = strArrOne.filter((strTag) => !strArrTwo.includes(strTag));
      result = result.map((item) => (item = JSON.parse(item)));
      return result;
    },
  },
  watch: {
    showCustomerDialog: {
      handler(newVal) {
        if (!newVal) {
          this.customerForm = {
            name: "",
            company: "",
            contact: "",
            telephone: "",
            area: "",
            address: "",
            selectedTags: [],
            email: "",
            qq: "",
          };
        }
      },
    },
    showTagDialog(newVal) {
      if (!newVal) {
        this.willUpdateCustomer = {
          userId: 0,
          xbId: 0,
          name: "",
          contact: "",
          telephone: "",
          status: 0,
          statusDesc: "",
          createTime: "",
          tags: [],
        };
        this.selectedTags = [];
      }
    },
  },
  activated() {
    if (this.$route.params.change) {
      this._getClientList(true);
    }
  },
  methods: {
    changeIsAccount() {
      this.options.hideDisabledFlag = this.filterClient.hideDisabledFlag?1:0;
      this._getClientList();
    },
    changeBindSalespersonFlag() {
      this.options.bindEmployee = this.filterClient.bindEmployee;
      this._getClientList();
    },
    // 筛选客户
    toFilterClient() {
      // 将当前页面重置为初始页面
      this.currentPage = 1;
      this.searchWithNoParam = false;
      let startTime = "";
      let endTime = "";
      if (!this.filterClient.createTime) {
        startTime = "";
        endTime = "";
      } else {
        startTime = this.filterClient.createTime[0];
        endTime = this.filterClient.createTime[1];
      }
      // 将查询参数记录起来
      this.options = Object.assign(this.options, {
        name: this.filterClient.name,
        label: this.filterClient.tagId,
        status: this.filterClient.status,
        cusLevel: this.filterClient.clientGrade,
        hideDisabledFlag: this.filterClient.hideDisabledFlag?1:0,
        bindEmployee: this.filterClient.bindEmployee,
        startTime: startTime,
        endTime: endTime,
        currentPage: this.currentPage,
      });
      this._getClientList();
    },
    // 清空客户筛选条件
    resetClientForm() {
      this.$refs.filterClient.resetFields();
      this.toFilterClient();
    },
    // 导出表格
    exportExcel() {
      let options = {};
      options.name = this.options.name;
      options.label = this.options.label;
      options.status = this.options.status;
      options.startTime = this.options.startTime;
      options.endTime = this.options.endTime;
      options.hideDisabledFlag = this.options.hideDisabledFlag;
      dbExcel.getCustomerExcel(options).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    toAddTag(customer) {
      this.willUpdateCustomer = Object.assign(
        this.willUpdateCustomer,
        customer
      );
      this.willUpdateCustomer.tags.map((value) => {
        this.selectedTags.push(value.id);
      });
      this._showTagDialog();
    },
    toDetail(customer) {
      let xbId = customer.xbId;
      this.$router.push({
        path: "/admin/client/client-manage-index/client-detail?xbId",
        query: {
          xbId: xbId,
        },
      });
    },
    toCheckClient(customer) {
      // 审核客户
      this.$confirm("是否审核通过?", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
        type: "warning",
      })
        .then(() => {
          let data = {
            xbId: customer.xbId,
            status: xbUserStatusEnum.effective,
          };
          this._updateClientStatus(data);
        })
        .catch(action => {
          if (action === 'cancel') {
            let data = {
              xbId: customer.xbId,
              status: xbUserStatusEnum.notPass,
            };
            this._updateClientStatus(data);
          }
        });
    },
    updateClientStatus(customer) {
      let status;
      switch (customer.status) {
        case xbUserStatusEnum.effective:
          status = xbUserStatusEnum.unEffective;
          break;
        case xbUserStatusEnum.unEffective:
          status = xbUserStatusEnum.effective;
          break;
        case xbUserStatusEnum.notPass:
          status = xbUserStatusEnum.effective;
          break;
        default:
          break;
      }
      let xbId = customer.xbId;
      let data = {
        xbId,
        status,
      };
      this._updateClientStatus(data);
    },
    cancelAddTag() {
      this.selectedTags = [];
      this._hideTagDialog();
    },
    saveAddTag() {
      // 判断新加的标签个数加上已有的标签个数是否超过限制个数
      let totalTagNum = this.selectedTags.length;
      console.log(totalTagNum);
      console.log(MAX_TAG_NUM);
      if (totalTagNum > MAX_TAG_NUM) {
        // 超过标签限制个数了
        this.$alert("最多添加五个标签", "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return false;
      }
      let selectedTags = [];
      this.selectedTags.map((item) => {
        selectedTags.push(item);
      });
      let data = {
        userId: this.willUpdateCustomer.userId,
        labelId: selectedTags,
      };
      this._addTagForClient(data);
      // 清空选择的标签
      this.selectedTags = [];
      // 隐藏添加标签弹框
      this._hideTagDialog();
    },
    toAddClient() {
      this._showClientDialog();
    },
    addNewCustomer() {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          let data = {
            userName: this.customerForm.name,
            companyName: this.customerForm.company,
            contact: this.customerForm.contact,
            telephone: this.customerForm.telephone,
            province: this.customerForm.area[0],
            city: this.customerForm.area[1],
            regions: this.customerForm.area[2] ? this.customerForm.area[2] : 0,
            address: this.customerForm.address,
            cusLabel: this.customerForm.selectedTags,
            levelId: this.customerForm.clientGrade,
            email: this.customerForm.email,
            qq: this.customerForm.qq,
          };
          this._addClient(data);
        } else {
          return false;
        }
      });
    },
    resetCustomerForm() {
      this._hideClientDialog();
      this.$refs.customerForm.resetFields();
    },
    handleQueryChange(query) {
      this.options.currentPage = query.currentPage;
      this._getClientList();
    },
    _showTagDialog() {
      this.showTagDialog = true;
    },
    _hideTagDialog() {
      this.showTagDialog = false;
    },
    _showClientDialog() {
      this.showCustomerDialog = true;
    },
    _hideClientDialog() {
      this.showCustomerDialog = false;
    },
    // 获取城市列表数据
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        this.addressList = res;
      });
    },
    // 获取客户
    _getClientList(type) {
      console.log("获取客户列表");
      let options = this.options;
      if (type === undefined) options.bindEmployee = this.options.bindEmployee ? false : true;
      dbClient.getClientList(options).then((res) => {
        if (res.success) {
          let { currentPage, totalNum, items } = res.result;
          this.currentPage = currentPage;
          this.customerListTotal = totalNum;
          // 先置空
          this.customerList = [];
          items.map((item) => {
            let tagList = item.cusLabelValue ? item.cusLabelValue : [];
            let tags = [];
            tagList.map((item) => {
              tags.push({
                id: item.customerLabelId,
                name: item.name,
              });
            });
            this.customerList.push({
              userId: item.userId,
              xbId: item.id,
              name: item.name,
              // 登录账号
              levelName: item.levelName ? item.levelName : "--",
              userName: item.userName,
              contact: item.contact,
              telephone: item.telephone,
              status: item.status,
              statusDesc: statusDescEnum[item.status],
              tags: tags,
              // lastLoginTime: item.lastLoginTime
              //   ? formaTimeToSecond(item.lastLoginTime)
              //   : "",
            });
          });
        }
      });
    },
    // 获取等级列表
    _getGradeListData() {
      dbClient.getClientGradeList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.clientGradeList = arr;
        }
      });
    },
    _getClientTagList(currentPage) {
      dbClient
        .getClientTagList(currentPage)
        .then((res) => {
          if (res.success) {
            console.log("客户标签列表--", res.result);
            // 先置空
            this.tagList = [];
            res.result.map((item) => {
              this.tagList.push({
                id: item.id,
                name: item.value,
              });
            });
            console.log("全部标签", this.tagList);
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((e) => {
          console.log("客户标签列表异常", e);
        });
    },
    _addTagForClient(data) {
      dbClient
        .addTagForClient(data)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              center: true,
              message: "添加成功！",
              duration: 2000,
            });
            this._getClientList();
          } else {
            this.$message({
              type: "error",
              center: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            center: true,
            message: "添加失败，请重试！",
            duration: 2000,
          });
        });
    },
    _updateTagForClient(data) {
      dbClient
        .updateTagForClient(data)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              center: true,
              message: "修改成功！",
              duration: 2000,
            });
          } else {
            this.$message({
              type: "error",
              center: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            center: true,
            message: "修改失败，请重试！",
            duration: 2000,
          });
        });
    },
    _deleteTagForClient(data) {
      dbClient
        .deleteTagForClient(data)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              center: true,
              message: "删除成功！",
              duration: 2000,
            });
          } else {
            this.$message({
              type: "error",
              center: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            center: true,
            message: "删除失败，请重试！",
            duration: 2000,
          });
        });
    },
    _addClient(data) {
      dbClient
        .addClient(data)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              center: true,
              message: "添加成功！",
              duration: 2000,
            });
            this._getClientList();
            this._hideClientDialog();
          } else {
            this.$message({
              type: "error",
              center: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            center: true,
            message: "添加失败，请重试！",
            duration: 2000,
          });
          this._hideClientDialog();
        });
    },
    _updateClientStatus(data) {
      dbClient
        .updateClientStatus(data)
        .then((res) => {
          if (res.success) {
            this._getClientList();
          } else {
            this.$message({
              type: "error",
              center: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            center: true,
            message: "服务器错误，请重试！",
            duration: 2000,
          });
        });
    },
    /* 跳转优惠券 */
    toCoupon(row) {
      this.$router.push({
        path: '/admin/client/client-manage-index/client-coupon',
        query: {
          xbId: row.xbId,
          userId: row.userId
        }
      })
    },
    /* 跳转购买记录 */
    toPurchaseRecord(row) {
      this.$router.push({
        path: '/admin/client/client-manage-index/purchase-record',
        query: {
          userId: row.userId
        }
      })
    },
    //返回新的command对象
    beforeHandleCommand(index, command) {
      return {
        'index': index,
        'command':command
      }
    },
    handleCommand(command) {
      switch (command.index) { //角标index获取为command.index
        case 1:
          this.toCoupon(command.command)
          break;
        case 2:
          this.updateClientStatus(command.command)
          break;
        case 3:
          let userId = command.command.userId
          this.initClientPoints(userId)
          this.dialogIntegralVisible = true
          break;
        case 4:
          this.updateClientStatus(command.command)
          break;
        // case 5:
        //   this.$router.push({
        //     path: "/admin/client/client-manage-index/client-login",
        //     query: {
        //       userId: command.command.userId
        //     }
        //   });
        //   break;
        case 6:
          this.toPurchaseRecord(command.command)
          break;
      }
    },
    saveIntegral() {
      this.dialogIntegralVisible = false
    },
    // 某个客户对应的积分
    initClientPoints(userId) {
      dbClient
        .getClientPoints(userId)
        .then((res) => {
          if (res.success) {
            this.integralForm.integralAmount = res.result.totalPoints
            this.integralForm.usedPoint = res.result.usedPoints
            this.integralForm.availablePoints = res.result.availablePoints
            this.integralForm.overduePoints = res.result.expiredPoints
          } else {
            this.$message({
              type: "error",
              center: true,
              message: res.message,
              duration: 2000,
            });
          }
        })
    }
  },
  created() {
    console.log("组件初始化");
    if (Number(this.$route.query.status) >= 0) {
      this.filterClient.status = Number(this.$route.query.status);
      this.options.status = Number(this.$route.query.status);
    }

    this._getClientList();
    this._getClientTagList();
    this._getGradeListData();
    this._getDBAddressMock();
    this.operationList = getDBOperationPermission();
  },
  mounted() {
    this.$refs.clientList.style.width = `${this.$refs.formContainer.clientWidth}px`;
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
};
</script>

<style lang="scss" scoped>
.clients-manage {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .filter-custom-form-container {
    width: 100%;
    box-sizing: border-box;
    margin: 16px 0 24px 0;
    padding: 22px 20px 26px 20px;
    background: rgba(245, 247, 250, 1);
    border-radius: 4px;
    .container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      .item {
        margin-right: 24px;
      }
    }
    .operations {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 80px;
      .btn-blue {
        margin-right: 16px;
      }
      .reset-btn {
        cursor: pointer;
        font-size: 12px;
        color: rgba(61, 116, 242, 1);
        margin-left: 20px;
      }
    }
  }
  .table {
    .tags {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .tag {
        box-sizing: border-box;
        margin-right: 10px;
        margin-bottom: 5px;
        width: 80px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px 4px;
        font-size: 12px;
        color: #fff;
        border-radius: 6px;
        background: #2f89fc;
        cursor: pointer;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
    .tip {
      width: 100%;
    }
    .column-btn {
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      color: rgba(61, 116, 242, 1);
      cursor: pointer;
      margin-right: 8px;
    }
  }
  .pagination-tpl-container {
    padding: 10px 24px 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .add-tag-container {
    .title {
      font-size: 16px;
      color: #606266;
      font-weight: 550;
    }
    .content {
      box-sizing: border-box;
      border-top: 1px solid #939393;
      padding-top: 26px;
      .add-tag-value {
        margin-bottom: 24px;
        .desc {
          color: #606266;
          font-size: 14px;
        }
      }
      .operation {
        display: flex;
        justify-content: center;
        align-items: center;
        .btn {
          width: 96px;
          height: 32px;
        }
      }
    }
  }
  .operation {
    display: flex;
    justify-content: flex-start;
  }
}
</style>

<style lang="scss">
#clientsManage {
  .el-form-item.is-error {
    .el-input__inner {
      border-color: #e3e3e3;
    }
  }
  .table {
    box-sizing: border-box;
    .el-table {
      width: 100%;
      overflow: auto;
      box-sizing: border-box;
      .el-table__body-wrapper {
        .el-table__body {
          tbody {
            .el-table__row {
              .cell {
                height: auto;
                padding-right: 0;
                line-height: 16px;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                .white {
                  display: inline-block;
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  background: #fff;
                  margin-right: 5px;
                }
                .green {
                  display: inline-block;
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  background: #2ad346;
                  margin-right: 5px;
                }
                .orange {
                  display: inline-block;
                  width: 5px;
                  height: 5px;
                  border-radius: 50%;
                  margin-right: 5px;
                  background: #f49064;
                }
              }
              td {
                height: 72px;
                &:nth-child(7) {
                  .cell {
                    padding-right: 0;
                    height: 60px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
            }
          }
        }
      }

      .el-table__fixed-right {
        box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.11);
        th {
          padding: 0;
          .cell {
            height: 32px;
            text-align: center;
            background: #f5f7fa;
          }
        }
        td {
          padding: 0;
          .cell {
            height: 71px;
            line-height: 70px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            .up-down-update {
              flex: 2;
              display: flex;
              justify-content: space-around;
              .update {
                margin-right: 5px;
              }
            }
            > .el-button {
              flex: 1;
            }
          }
          background: rgba(245, 247, 250, 1);
          .el-button--text {
            color: #3d74f2;
            font-size: 12px;
          }
        }
      }
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #3d74f2;
      font-size: 12px;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
  }
  // 筛选客户form表单
  .filter-customer-form.el-form {
    .el-form-item {
      display: flex;
      .el-form-item__content {
        width: 160px;
      }
      @media screen and (max-width: 1418px) {
        .el-form-item__content {
          width: 126px;
        }
      }
    }
    .el-form-item.check-item {
      display: flex;
      margin-right: 24px;
      .el-form-item__content {
        width: 120px;
      }
    }
    .date-item {
      .el-date-editor--daterange.el-input,
      .el-date-editor--daterange.el-input__inner,
      .el-date-editor--timerange.el-input,
      .el-date-editor--timerange.el-input__inner {
        width: 280px;
      }
    }
  }
  // 添加客户标签弹框
  .add-tag-container {
    .el-dialog {
      width: 420px;
      .el-dialog__header {
        height: 48px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .el-dialog__body {
        box-sizing: border-box;
        .content {
          padding-top: 16px;
          border-top: 1px solid #e3e3e3;
          .el-select {
            .el-input {
              width: 306px;
            }
          }
        }
      }
    }
  }
  // 新增客户
  .add-customer-container {
    .el-dialog {
      width: 420px;
      .el-dialog__header {
        height: 48px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .el-dialog__body {
        box-sizing: border-box;
        .content {
          padding-top: 16px;
          border-top: 1px solid #e3e3e3;
          .el-cascader {
            .el-input {
              width: 290px;
            }
          }
          .el-select {
            .el-input {
              width: 290px;
            }
          }
        }
      }
    }
  }
  .dialogIntegral {
    .el-dialog__header {
      padding: 0;
      padding-left: 20px;
      font-size: 16px;
      font-weight: bold;
      color: #666666;
      border-bottom: 1px solid #eee;
    }
    .el-dialog__body {
      padding: 20px 45px 20px 20px;
    }
    .el-dialog__footer {
      padding: 20px 0px;
      border-top: 1px solid #eee;
      .dialogIntegral-footer {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
/* 下拉菜单样式 */
.client-dropdown {
  .el-dropdown-menu__item {
    color: #3d74f2;
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #ecf5ff;
    color: #3d74f2;
  }
}
</style>
